import {combineReducers} from 'redux';
import {auth} from './Auth'
import {plugins} from './Plugins'

const rootReducer = combineReducers({
	auth,plugins
});
export default rootReducer;
